/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypeDefinitionDTO } from './TypeDefinitionDTO';
import {
    TypeDefinitionDTOFromJSON,
    TypeDefinitionDTOFromJSONTyped,
    TypeDefinitionDTOToJSON,
} from './TypeDefinitionDTO';

/**
 * 
 * @export
 * @interface AssignComplexOperation
 */
export interface AssignComplexOperation {
    /**
     * 
     * @type {TypeDefinitionDTO}
     * @memberof AssignComplexOperation
     */
    type: TypeDefinitionDTO;
    /**
     * 
     * @type {string}
     * @memberof AssignComplexOperation
     */
    content: string;
}

/**
 * Check if a given object implements the AssignComplexOperation interface.
 */
export function instanceOfAssignComplexOperation(value: object): value is AssignComplexOperation {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function AssignComplexOperationFromJSON(json: any): AssignComplexOperation {
    return AssignComplexOperationFromJSONTyped(json, false);
}

export function AssignComplexOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignComplexOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': TypeDefinitionDTOFromJSON(json['__type']),
        'content': json['__content'],
    };
}

export function AssignComplexOperationToJSON(value?: AssignComplexOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        '__type': TypeDefinitionDTOToJSON(value['type']),
        '__content': value['content'],
    };
}

